/**
 * @license lucide-vue-next v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const SignalZero = createLucideIcon("signal-zero", [["path", { d: "M2 20h.01", key: "4haj6o" }]]);

export { SignalZero as default };
//# sourceMappingURL=signal-zero.js.map
